<micro-lookup domain="np" obj="mnos" url="/mnos" [key]="mnoId" [link]="link"></micro-lookup>
